export default __webpack_public_path__ + "static/media/splash.039243c2.mp3";